import React from 'react';

type ChevronIconProps = {
  width?: number;
  height?: number;
  direction?: 'top' | 'right' | 'bottom' | 'left';
  className?: string;
  color?: string;
  fill?: string;
};

function ChevronIcon({
  width = 15,
  height = 9,
  direction = 'right',
  ...rest
}: ChevronIconProps) {
  // tslint:disable max-line-length
  if (direction === 'top') {
    return (
      <svg {...rest} width={width} height={height} viewBox="0 0 15 9">
        <path d="M12.5261632,8.57454849 C13.0957305,9.14548533 14.0150012,9.14125662 14.5794117,8.56510341 C15.1438223,7.98895019 15.1396419,7.05904996 14.5700746,6.48811312 L8.52195573,0.425451418 C7.9560479,-0.141817139 7.0439521,-0.141817139 6.47804427,0.425451418 L0.429925367,6.48811312 C-0.139641943,7.05904996 -0.143822313,7.98895019 0.42058825,8.56510341 C0.984998813,9.14125662 1.90426951,9.14548533 2.47383682,8.57454849 L7.5,3.53629982 L12.5261632,8.57454849 Z" />
      </svg>
    );
  }

  if (direction === 'right') {
    return (
      <svg {...rest} width={width} height={height} viewBox="0 0 9 15">
        <path d="M5.48684777,7.50397408 L0.404874119,12.5450213 C-0.163670797,13.1089875 -0.167382519,14.0270692 0.396583755,14.5956142 C0.960550029,15.1641591 1.87863175,15.1678708 2.44717666,14.6039045 L8.57095596,8.52944164 C9.1443064,7.96070854 9.14251955,7.03315161 8.56698216,6.46663173 L2.44320287,0.438799698 C1.87248933,-0.12297191 0.954428727,-0.115723044 0.39265712,0.454990493 C-0.169114488,1.02570403 -0.161865622,1.94376463 0.408847915,2.50553624 L5.48684777,7.50397408 Z" />
      </svg>
    );
  }

  if (direction === 'left') {
    return (
      <svg {...rest} width={width} height={height} viewBox="0 0 9 15">
        <path d="M3.49145847,7.49386116 L8.57081112,2.45683138 C9.13943537,1.8929451 9.14327626,0.974863911 8.57938997,0.406239659 C8.01550369,-0.162384593 7.0974225,-0.166225475 6.52879825,0.397660808 L0.405018956,6.47041471 C-0.169368198,7.04001588 -0.166605723,7.96945951 0.411157169,8.53563627 L6.53493647,14.5366128 C7.10690259,15.0971091 8.02494472,15.0878109 8.58544096,14.5158448 C9.1459372,13.9438787 9.13663903,13.0258365 8.56467291,12.4653403 L3.49145847,7.49386116 Z" />
      </svg>
    );
  }

  return (
    <svg {...rest} width={width} height={height} viewBox="0 0 15 9">
      <path d="M7.5,5.66602416 L2.43674491,0.431396522 C1.9082727,-0.114962532 1.01849523,-0.14659907 0.449371305,0.360734337 C-0.119752618,0.868067744 -0.15270734,1.72225426 0.375764875,2.26861331 L6.46950998,8.56860926 C7.02586699,9.14379691 7.97413301,9.14379691 8.53049002,8.56860926 L14.6242351,2.26861331 C15.1527073,1.72225426 15.1197526,0.868067744 14.5506287,0.360734337 C13.9815048,-0.14659907 13.0917273,-0.114962532 12.5632551,0.431396522 L7.5,5.66602416 Z" />
    </svg>
  );
  // tslint:enable max-line-length
}

export default ChevronIcon;
